import { Variants } from 'framer-motion'

export const clipVar: Variants = {
  initial: {
    opacity: 0
  },
  fadeIn: {
    opacity: 1
  },
  fadeOut: {
    opacity: 0
  }
}
